import ThemeToggle from "components/AppNav/ThemeToggle";
import AnnouncementDialog from "components/Common/AnnouncementDialog/AnnouncementDialog";
import FeedbackForm from "components/Feedback/FeedbackForm";
import { AnnouncementDialogContent } from "./announcementConfig";

export interface FeatureAnnouncementDialogProps {
  isOpen: boolean;
  onClose: () => void;
  content: AnnouncementDialogContent;
}

/**
 * The current announcement, rendered from its config: what we shipped, the
 * control for it, and the question we are asking this round.
 *
 * Everything here is driven by announcementConfig, so the next release changes
 * copy rather than components.
 */
const FeatureAnnouncementDialog = ({
  isOpen,
  onClose,
  content,
}: FeatureAnnouncementDialogProps) => (
  <AnnouncementDialog
    isOpen={isOpen}
    onClose={onClose}
    title={content.title}
    data-testid="feature-announcement-dialog"
    action={content.inlineControl === "theme" ? <ThemeToggle /> : undefined}
    footer={
      content.feedback ? (
        <FeedbackForm
          prompt={content.feedback.prompt}
          submitLabel={content.feedback.submitLabel}
          placeholder="Whatever is on your mind…"
        >
          <p className="mb-2">{content.feedback.intro}</p>
          <p className="mb-2">
            <strong>{content.feedback.prompt}</strong>
          </p>
        </FeedbackForm>
      ) : undefined
    }
  >
    {content.body}
  </AnnouncementDialog>
);

export default FeatureAnnouncementDialog;
